import React from 'react'
import PropTypes from 'prop-types'

import S from './Loader.styled'
import { Loader as LoaderSvg } from '../Svg'

const loaderSize = ['l', 'm', 's']

const Loader = ({
  className,
  hasPadding = true,
  size = 's',
  isPage = false,
}) => {
  return (
    <S.Loader
      className={className}
      hasPadding={hasPadding}
      size={size}
      isPage={isPage}
    >
      <LoaderSvg className="icon" />
    </S.Loader>
  )
}

Loader.propTypes = {
  className: PropTypes.string,
  hasPadding: PropTypes.bool,
  size: PropTypes.oneOf(loaderSize),
  isPage: PropTypes.bool,
}

export default Loader
